export type XylView = {
	init: <T extends HTMLElement>($views: T[]) => void | Promise<void>;
	view?: string;
	/**
	 * @deprecated Use @see {@link asyncModule}
	 */
	async?: boolean;
	/**
	 * @deprecated Use @see {@link DomElementsBase}
	 */
	settings?: Record<string, unknown>;
};

export function createXylView(xylView: XylView) {
	return xylView;
}
